// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

// These IDs need to be kept in sync with RendererId.cs
export enum WebRendererId {
  Default = 0,
  Server = 1,
  WebAssembly = 2,
  WebView = 3,
  WebAssemblyOutOfProcess = 4,
}
